<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh; display: flex;margin-top: -70px;"
  >

    <h2 class="text-center" style="width: 100%;">
      <v-icon x-large class="mb-5">mdi-close-octagon-outline</v-icon>
      <br />
      Not available on mobile
    </h2>
  </v-col>
  <v-container v-else class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0 mb-5">
        <select-project
          v-model="project"
          class="mr-5 mt-0"
          style="max-width: 200px"
        ></select-project>
        <v-text-field
          v-model="form.search"
          label="Login"
          class="mr-5 mt-0"
          hide-details=""
          style="max-width: 200px"
        />
        <v-checkbox
          v-model="form.vip"
          label="VIP"
          class="mr-5 mt-3"
          hide-details
          true-value="1"
          false-value="0"
        />
        <v-checkbox
          v-model="form.blocked"
          label="Blocked"
          hide-details
          class="mr-5 mt-3"
          true-value="1"
          false-value="0"
        />
        <v-checkbox
          v-model="form.closed"
          label="Closed"
          class="mr-5 mt-3"
          hide-details
          true-value="1"
          false-value="0"
        />
        <v-checkbox
          v-model="form.no_dep"
          label="No dep"
          class="mr-5 mt-3"
          hide-details
          true-value="1"
          false-value="0"
        />

        <v-btn color="info" v-on:click="search" class="mt-2" :disabled="loading" :loading="loading">Search</v-btn>
      </v-row>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
        :height="`calc(100vh - 185px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        :server-items-length="totalItems"
        :options.sync="options"
        :items-per-page="10"
        :footer-props="{'items-per-page-options': [10, 100, 200, 300]}"
        fixed-header
        group-by="login"
        class="retention-dt"
        style="z-index: 0; position: relative; width: 100%"
      >
        <template v-slot:group="{ items, group }">
          <tr class="v-row-group__header">
            <td :colspan="headers.length">
              <span style="position: sticky; left: 15px">
                <b><a :href="'/user-management/' + group" style="color: rgba(0, 0, 0, 0.87);" target="_blank">{{ group }}</a></b>
                <b class="ml-2">({{ items[0].currency }})</b>
                <span class="ml-2" v-html="duplicates(items[0])" />
              </span>
            </td>
          </tr>
          <tr v-for="item of items">
            <td v-for="h of headers" :class="'retention-cell retention-cell-' + item[h.value].class + ' ' + classMap[item[h.value].class]">
              {{ item[h.value].deposit }}
              <div>
                <span>day: {{ item[h.value].pass + 1 }}</span>
                <v-checkbox
                  v-if="item[h.value].deposit == 0"
                  v-model="item[h.value].approve"
                  label="Sent"
                  class="mt-0"
                  readonly
                  hide-details
                />
              </div>
            </td>
          </tr>
        </template>


        <template v-slot:footer>
          <v-btn
            @click="listForToday.dialog = true"
            color="info"
            style="float: left;"
            class="mt-5"
          >
            List for today
          </v-btn>
        </template>

      </v-data-table>
    </v-card>

    <v-dialog
      v-model="listForToday.dialog"
      v-if="listForToday.dialog"
      width="70%"
      style="min-width: 600px"
    >
      <v-card>
        <v-card-title class="headline">List for Today</v-card-title>

        <v-card-text>
          <v-data-table
            :loading="listForToday.loading"
            :headers="listForToday.headers"
            :items="listForToday.items"
            :height="`calc(100vh - 255px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
            :items-per-page="-1"
            :footer-props="{'items-per-page-options': [-1]}"
            fixed-header
            hide-default-footer
            style="z-index: 0; position: relative; width: 100%"
          >
            <template v-slot:item.day="{ item }">
              {{ item.day + 1 }}
            </template>
            <template v-slot:item.login="{ item }">
              <a :href="'/user-management/' + item.login " target="_blank">{{ item.login }}</a>
            </template>
            <template v-slot:item.action="{ item }">
              <template v-if="item.action.freespin">Freepsin: {{ item.action.freespin }} {{ item.action.game_name }}</template>
              <template v-if="item.action.notify">Notify Admin</template>
              <template v-if="item.active_withdraw > 0">Active Withdraw</template>
            </template>
            <template v-slot:item.sent="{ item }">
              <v-checkbox
                v-model="item.sent"
                class="mt-0"
                hide-details
                disabled
                readonly
              />
            </template>
            <template v-slot:item.to_send="{ item }">
              <v-checkbox
                v-model="item.to_send"
                class="mt-0"
                hide-details
                disabled
                readonly
              />
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <select-project
            v-model="listForToday.project"
            :items="projectList"
            label="Project"
            hide-details
            class="ml-5 mt-0 mb-2"
            style="max-width: 200px"
          />
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="listForToday.dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style>

  .retention-dt .v-row-group__header td {
    height: 30px !important;
    border-top: 1px solid;
    border-top-color: #CECECE !important;

  }

  .v-application td.retention-cell.lighten-3,
  .v-application td.retention-cell.lighten-4,
  td.retention-cell {
    white-space: nowrap;
    padding: 3px 5px !important;
    border-right: 1px solid #CECECE !important;
    border-right-color: #CECECE !important;
    border-bottom: none !important;
  }

  .retention-cell:last-child {
    border-right: none;
  }

  .retention-cell > div {
    width: 120px;
    font-size: 12px;
    font-weight: bold;
  }

  .retention-cell > div > span {
    margin-top: 5px;
    display: inline-block;
  }

  .retention-cell > div > .v-input {
    float: right;
    font-size: 12px;
    font-weight: bold;
    zoom: 0.85;
  }

  .retention-cell-verified {
    color: #1B5E20 !important;
  }

  .retention-cell-warning {
    color: #827717 !important;
  }

  .retention-cell-danger {
    color: #D50000 !important;
  }
</style>

<script>
  import moment from 'moment'
  import { get, clone } from 'lodash'
  import { API } from '@/utils/api'
  import { duplicatesFlags } from '@/utils/helper'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {

    components: { SelectProject },

    data: () => ({
      listForToday: {
        dialog: false,
        project: null,
        headers: [
          { text: 'Login', value: 'login', sortable: false },
          { text: 'Day', value: 'day', sortable: false },
          { text: 'Balance', value: 'data.balance', sortable: false },
          { text: 'Bonus', value: 'data.bonus', sortable: false },
          { text: 'Currency', value: 'currency', sortable: false },
          { text: 'Dep Count', value: 'dep_count', sortable: false },
          { text: 'Dep Sum', value: 'dep_sum_total', sortable: false },
          { text: 'Sent', value: 'sent', sortable: false },
          { text: 'Action', value: 'action', sortable: false },
          { text: 'To Send', value: 'to_send', sortable: false },
        ],
        items: [],
      },
      classMap: {
        verified: 'light-green lighten-3',
        warning: 'yellow lighten-3',
        danger: 'red lighten-4',
      },
      loading: false,
      project: null,
      form: {
        search: '',
        vip: 0,
        closed: 0,
        blocked: 0,
        no_dep: 0,
      },
      totalItems: -1,
      options: {},
      items: []
    }),

    computed: {

      headers () {
        let h = [
          // { text: 'Login', value: 'login', sortable: false },
        ]

        for (let i = 1; i < 31; i++) {
          let d = moment().subtract(i, 'day')
          h.push({ text: d.format('YYYY-MM-DD'), value: d.format('YYYY-MM-DD 00:00:00'), sortable: false })
        }

        return h
      },
    },

    watch: {
      'listForToday.project' () {
        this.loadListForToday()
      },
      'listForToday.dialog' (val) {
        if (val) {
          this.listForToday.project = clone(this.project)
        }
      },

      options: {
        handler () {
          this.search()
        },
      }
    },

    methods: {
      duplicates: function (row) {
        return duplicatesFlags(row.duplicates)
      },

      search: function () {
        this.loading = true

        API.call('/$v/retention/list.json', { ...this.options, ...this.form }, null, this.project).then(resp => {

          this.items = get(resp, 'data', [])
          this.totalItems = resp.total

          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },

      loadListForToday: function () {
        this.listForToday.loading = true

        API.call('/$v/retention/list_for_today.json', {}, null, this.listForToday.project).then(resp => {

          this.listForToday.items = get(resp, 'data', [])

          this.listForToday.loading = false
          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.listForToday.loading = false
        })
      },
    },

  }
</script>


